import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { ref, onValue } from "firebase/database";
import { toast } from "react-toastify";
import { auth, database } from "../firebase"; // adjust path if needed
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [pointsData, setPointsData] = useState([
    {
      label: "Points Earned",
      value: 0,
      icon: "🪙",
      color: "#8F27FF",
    },
    {
      label: "Points Redeemed",
      value: 0,
      icon: "🎫",
      color: "#00bfa5",
    },
    {
      label: "Points Available",
      value: 0,
      icon: "📦",
      color: "#2979ff",
    },
    {
      label: "Points Expired",
      value: 0,
      icon: "🕒",
      color: "#d50000",
    },
    {
      label: "Points in Review",
      value: 0,
      icon: "📝",
      color: "#ffa000",
    },
    {
      label: "Points Rejected",
      value: 0,
      icon: "🚫",
      color: "#d50000",
    },
  ]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const userId = user.uid;
        const userRef = ref(database, "users/" + userId);
        const pointRef = ref(database, "Points/" + userId);

        onValue(pointRef, (snapshot) => {
          if (snapshot.exists()) {
            let data = snapshot.val();
            let tempData = JSON.parse(JSON.stringify(pointsData));
            tempData[0].value = data?.point_earned || 0;
            tempData[1].value = data?.point_redeemed || 0;
            tempData[2].value = data?.point_available || 0;
            tempData[3].value = data?.point_expired || 0;
            tempData[4].value = data?.point_review || 0;
            tempData[5].value = data?.point_rejected || 0;
            setPointsData(tempData);
          } 
        });

        onValue(userRef, (snapshot) => {
          if (snapshot.exists()) {
            setUserData(snapshot.val());
          } else {
            toast.error("No user data available");
          }
        });
      } else {
        // toast.warning("User not logged in");
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        {userData?.name ? <h3 style={styles.highlightedTitle}>
          Welcome{userData?.name ? `, ${userData?.name}` : ""}
        </h3> : null}

        {userData?.name ? <div style={styles.grid}>
          {pointsData.map((point, index) => (
            <div key={index} style={{ ...styles.card, borderLeftColor: point.color }}>
              <div style={{ ...styles.icon, color: point.color }}>{point.icon}</div>
              <div style={styles.value}>{point.value}</div>
              <div style={styles.label}>{point.label}</div>
            </div>
          ))}
        </div>: null}

        {!userData?.name ? <div style={styles.loaderWrapper}>
            <div style={styles.loader}></div>
            <p style={styles.loadingText}>Loading...</p>
          </div> : null}
      </div>
    </div>
  );
};

export default Dashboard;

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    padding: 20,
    background:  "linear-gradient(145deg, #F3EBFF, #ffffff)",
    minHeight: "100vh",
  },
  content: {
    width: "100%",
    maxWidth: 960,
  },
 highlightedTitle: {
    fontSize: 28,
    fontWeight: 800,
    background: "linear-gradient(to right, #8F27FF, #15007d)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    textAlign: "center",
    marginBottom: 36,
    letterSpacing: 1,
    textTransform: "uppercase",
    animation: "slideDown 0.5s ease-out",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: 20,
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: 12,
    borderLeft: "6px solid",
    padding: "20px 16px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    animation: "fadeIn 0.3s ease",
  },
  icon: {
    fontSize: 28,
    marginBottom: 10,
  },
  value: {
    fontSize: 24,
    fontWeight: "700",
    color: "#333",
    marginBottom: 5,
  },
  label: {
    fontSize: 14,
    color: "#666",
    textAlign: "center",
  },
  loaderWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: 60,
  },
  loader: {
    width: 48,
    height: 48,
    border: "6px solid #f3f3f3",
    borderTop: "6px solid #15007d",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: "#15007d",
    fontWeight: "600",
    animation: "pulse 1.5s ease-in-out infinite",
  },
};
